export default __webpack_public_path__ + "static/study-1-small-a42e060168bdc9e561f930fe7a2259b2.svg";